import script from "./PaymentConditionPill.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentConditionPill.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentConditionPill.vue?vue&type=style&index=0&id=52a2d7bd&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52a2d7bd"]])

export default __exports__